import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { formatErr, startCheckout } from "@/lib/api";

const FIELDS = [
  ["name", "Your name", "text", true],
  ["company", "Business name", "text", true],
  ["email", "Work email", "email", true],
  ["phone", "Phone (optional)", "tel", false],
  ["password", "Password (min 6 characters)", "password", true],
];

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const plan = params.get("plan");
  const [f, setF] = useState({ name: "", company: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(f);
      if (plan) await startCheckout(plan);
      else nav("/app");
    } catch (err) {
      setError(formatErr(err));
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Create your business account" subtitle={plan ? `You'll be taken to secure checkout for the ${plan} plan next.` : "Browse vetted candidates in minutes."}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {FIELDS.map(([k, label, type, req]) => (
          <div key={k} className="space-y-1.5">
            <Label htmlFor={k}>{label}</Label>
            <Input id={k} data-testid={`register-${k}-input`} type={type} required={req} minLength={k === "password" ? 6 : undefined} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
          </div>
        ))}
        {error && <p data-testid="register-error" className="text-sm text-red-600">{error}</p>}
        <Button type="submit" disabled={busy} data-testid="register-submit-button" className="w-full h-11">{busy ? "Creating account…" : plan ? "Create account & continue to payment" : "Create account"}</Button>
      </form>
      <p className="mt-6 text-sm text-stone-600">Already a member? <Link to="/login" data-testid="go-login-link" className="font-medium text-slate-900 underline underline-offset-4">Sign in</Link></p>
    </AuthShell>
  );
}
